import { render, staticRenderFns } from "./SYCodeUserDetail.vue?vue&type=template&id=d6fb2c64&"
import script from "./SYCodeUserDetail.vue?vue&type=script&lang=js&"
export * from "./SYCodeUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./SYCodeUserDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports